import { Environment } from './model';

export const environment: Environment = {
    production: true,
    dbName: 'cloudpilot',
    debug: false,
};
